import React from "react";

import {
  formatEventDate,
  formatEventTime,
  getEventType,
} from "../utils/convocationsAdmin.utils";

import { EventStatusPill, EventTypeBadge } from "../ui/EventBadges";

import ConvocationActions from "./ConvocationActions";
import ConvocationsEmptyState from "./ConvocationsEmptyState";
import EventIdentity from "./EventIdentity";

function MobileSkeleton() {
  return (
    <div className="space-y-3">
      {[1, 2, 3].map((item) => (
        <div
          key={item}
          className="h-64 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-800"
        />
      ))}
    </div>
  );
}

export default function ConvocationsMobileList({
  rows,
  loading,
  onRegister,
  onRegisterByGroup,
  onUnregister,
  onView,
}) {
  if (loading) {
    return (
      <div className="lg:hidden">
        <MobileSkeleton />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <section className="rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900 lg:hidden">
        <ConvocationsEmptyState />
      </section>
    );
  }

  return (
    <section className="space-y-3 lg:hidden">
      {rows.map((event) => {
        const eventTime = formatEventTime(event.start);

        return (
          <article
            key={event.id}
            className="overflow-hidden rounded-3xl border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900"
          >
            <div className="h-1 bg-gradient-to-r from-[#013E8E] via-blue-500 to-[#4CA82F]" />

            <div className="p-4 sm:p-5">
              <div className="flex items-start justify-between gap-3">
                <EventIdentity event={event} />

                <EventStatusPill start={event.start} />
              </div>

              <div className="mt-4 flex flex-wrap items-center gap-2 border-y border-slate-100 py-3 dark:border-slate-800">
                <span className="text-xs font-medium capitalize text-slate-600 dark:text-slate-300">
                  {formatEventDate(event.start)}
                </span>

                <EventTypeBadge type={getEventType(event)} />
              </div>

              <div className="mt-4">
                <ConvocationActions
                  event={event}
                  onRegister={onRegister}
                  onRegisterByGroup={onRegisterByGroup}
                  onUnregister={onUnregister}
                  onView={onView}
                />
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
}
